<ng-container *ngIf="layout =='input-1'">
       <div class="input-1">
              <input class="form-control input-number__input" type="number" [ngClass]="{'form-control-sm': size === 'sm', 'form-control-lg': size === 'lg'}" [min]="options.min" [attr.max]="options.max ? options.max : null" [value]="value" [step]="options.step" [disabled]="options.disabled" [readOnly]="options.readonly"
                     (keydown)="checkDecimal($event)" (input)="input()" (blur)="onTouched()" #inputElement>

              <button type="button" class="input-number__add" (mousedown)="add()"  (touchstart)="add()"  [disabled]="options.disabled"></button>
              <button type="button" class="input-number__sub" (mousedown)="sub()" (touchstart)="sub()" [disabled]="options.disabled"></button>
       </div>
</ng-container>
<ng-container *ngIf="layout =='input-2'">
       <div class="input-2 flex flex-row items-center">
              <div class="quantity-btn relative">
                     <input class="form-control input-number__input border-none" type="number" [min]="options.min" [attr.max]="options.max ? options.max : null" [step]="options.step" [value]="value" [disabled]="options.disabled" [readOnly]="options.readonly" (keydown)="checkDecimal($event)" (input)="input()" (blur)="onTouched()"
                            #inputElement>

                     <button type="button" class="input-number__add" (mousedown)="add()"  (touchstart)="add()"[disabled]="options.disabled"></button>
                     <button type="button" class="input-number__sub" (mousedown)="sub()" (touchstart)="sub()" [disabled]="options.disabled"></button>
              </div>
              <div class="cart-btn">
                     <button appClick (click)="addToCart.emit(true)" style="padding: 0; padding-bottom: 3px;" mat-icon-button ><mat-icon svgIcon="add_to_cart_custom" style="color: white;"> </mat-icon></button>
              </div>
       </div>
</ng-container>
<ng-container *ngIf="layout =='input-3'">
       <div class="input-3">
              <input class="form-control input-number__input" type="number" [min]="options.min" [attr.max]="options.max ? options.max : null" [step]="options.step" [value]="value" [disabled]="options.disabled" [readOnly]="options.readonly" (keydown)="checkDecimal($event)" (input)="input()" (blur)="onTouched()" #inputElement>

              <button type="button" class="input-number__add" (mousedown)="add()"  (touchstart)="add()"[disabled]="options.disabled"></button>
              <button type="button" class="input-number__sub" (mousedown)="sub()" (touchstart)="sub()" [disabled]="options.disabled"></button>
       </div>
</ng-container>

<ng-container *ngIf="layout =='input-4'">
    <div class="input-4 flex flex-row items-center">
        <div class="quantity-btn relative">
               <input class="form-control input-number__input border-none rounded-s-full" type="number" [min]="options.min" [attr.max]="options.max ? options.max : null" [step]="options.step" [value]="value" [disabled]="options.disabled" [readOnly]="options.readonly" (keydown)="checkDecimal($event)" (input)="input()" (blur)="onTouched()"
                      #inputElement>

               <button type="button" class="input-number__add" (mousedown)="add()"  (touchstart)="add()"[disabled]="options.disabled"></button>
               <button type="button" class="input-number__sub" (mousedown)="sub()" (touchstart)="sub()" [disabled]="options.disabled"></button>
        </div>
        <div class="cart-btn  rounded-e-full">
               <button appClick (click)="addToCart.emit(true)" mat-icon-button><mat-icon svgIcon="add_to_cart_custom" style="color: white;"> </mat-icon></button>
        </div>
 </div>
</ng-container>

<ng-container *ngIf="layout =='input-5'">
    <div class="input-3">
           <input class="form-control input-number__input bg-white" type="number" [min]="options.min" [attr.max]="options.max ? options.max : null" [step]="options.step" [value]="value" [disabled]="options.disabled" [readOnly]="options.readonly" (keydown)="checkDecimal($event)" (input)="input()" (blur)="onTouched()" #inputElement>

           <button type="button" class="input-number__add" (mousedown)="add()"  (touchstart)="add()"[disabled]="options.disabled"></button>
           <button type="button" class="input-number__sub" (mousedown)="sub()" (touchstart)="sub()" [disabled]="options.disabled"></button>
    </div>
</ng-container>

